import { forwardRef, Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { EventDetailsModule } from '../event-details/event-details.module';
import { ProfileEntity } from '../profile/profile.entity';
import { EventFilesEntity } from './event-files.entity';
import { EventController } from './event.controller';
import { EventsEntity } from './event.entity';
import { EventService } from './event.service';

@Module({
    imports: [
        TypeOrmModule.forFeature([EventsEntity,EventFilesEntity,ProfileEntity]),
        forwardRef(() =>EventDetailsModule),
    ],
    controllers:[EventController],
    providers:[EventService],
    exports:[EventService],
})
export class EventsModule {}